"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TextOverflowHelper = function () {
  function TextOverflowHelper(options) {
    this.options = options || {
      mustStripStyle: false
    };
  }

  TextOverflowHelper.prototype.get = function (textWithHtml, options) {
    options = __assign(__assign({}, this.options), options || {});
    var suffix = options.suffix,
        mustStripStyle = options.mustStripStyle;

    if (suffix && options.length) {
      options.length -= suffix.length;
    }

    var container = document.createElement('div');
    container.innerHTML = mustStripStyle ? this.stripAttributeFromElements(textWithHtml, 'style') : textWithHtml;
    var elements = this.getMapping(container.childNodes);
    var counter = {
      current: 0,
      total: 0
    };
    this.cleanElements(options, elements, counter);
    var content = this.rebuildContent(elements);
    return {
      counter: counter,
      content: content
    };
  };

  TextOverflowHelper.prototype.getMapping = function (elements) {
    var collection = [];

    for (var _i = 0, _a = Array.from(elements); _i < _a.length; _i++) {
      var element = _a[_i];
      var content = {
        element: element,
        text: element.textContent,
        tag: element.nodeName
      };

      if (element.childNodes && element.childNodes.length > 0) {
        content.childNodes = this.getMapping(element.childNodes);
      }

      collection.push(content);
    }

    return collection;
  };

  TextOverflowHelper.prototype.stripAttributeFromElements = function (textWithHtml, attributes, selector) {
    var container = document.createElement('div');
    container.innerHTML = textWithHtml;

    if (typeof attributes === 'string') {
      attributes = [attributes];
    }

    var selectorElements = selector && container.querySelectorAll(selector);

    for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
      var attribute = attributes_1[_i];
      var allElements = selectorElements || container.querySelectorAll("[" + attribute + "]");

      for (var _a = 0, _b = Array.from(allElements); _a < _b.length; _a++) {
        var element = _b[_a];
        element.removeAttribute(attribute);
      }
    }

    return container.innerHTML;
  };

  TextOverflowHelper.prototype.cleanElements = function (options, elements, counter) {
    if (counter === void 0) {
      counter = {
        current: 0,
        total: 0
      };
    }

    var maxLength = options.length,
        suffix = options.suffix;
    var hasText = false;
    var lastIndex = -1;
    var index = -1;

    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
      var element = elements_1[_i];
      index++;
      var availableLength = maxLength - counter.current;

      if (element.tag === '#text') {
        var textLength = element.text.length;
        counter.total += textLength;

        if (availableLength > 0) {
          if (availableLength >= textLength) {
            counter.current += textLength;
          } else if (availableLength < textLength) {
            element.text = "" + element.text.substr(0, availableLength) + (suffix || '');
            counter.current = maxLength;
          }

          lastIndex = index;
        } else {
          element.text = '';
        }

        element.element.textContent = element.text;
        hasText = hasText || element.text.length > 0;
        element.hasText = element.text.length > 0;
      }

      if (element.childNodes) {
        element.hasText = this.cleanElements(options, element.childNodes, counter);

        if (element.hasText) {
          lastIndex = index;
        }

        hasText = hasText || element.hasText;
      }
    }

    if (lastIndex > -1) {
      for (var i = lastIndex + 1; i < elements.length; i++) {
        var element = elements[i];
        var childElement = element.element;
        var parentElement = childElement.parentElement;

        if (parentElement) {
          parentElement.removeChild(childElement);
        }

        elements.splice(i, 1);
        i--;
      }
    }

    return hasText;
  };

  TextOverflowHelper.prototype.rebuildContent = function (elements) {
    var container = document.createElement('div');

    for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
      var element = elements_2[_i];
      container.appendChild(element.element);
    }

    return container.innerHTML;
  };

  return TextOverflowHelper;
}();

exports.TextOverflowHelper = TextOverflowHelper;